import React, { Fragment, useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  Input,
} from "reactstrap"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"

import { Slide, toast, ToastContainer } from "react-toastify"
import { AvForm } from "availity-reactstrap-validation"
import FileDownload from "js-file-download"
import Select from "react-select"
import Switch from "react-switch"

// Laravel doit gérer target_type : 1 = tous, 2 = sélection.
const OPTIONS_ENSEIGNANTS = [
  { value: 1, label: "Tous les enseignants" },
  { value: 2, label: "Par enseignants" },
]

const DataTableAvisEnseignant = props => {
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [id, setId] = useState("")
  const [file, setFile] = useState(null)
  const fileInputRef = useRef(null)
  const [saving, setSaving] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  // Data Table
  const [orders, setOrders] = useState([])
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState("")
  const [enseignant, setEnseignant] = useState([])
  const [selectEnseignant, setSelectEnseignant] = useState([])
  const [selectOption, setSelectOption] = useState(null)
  const [status, setStatus] = useState(0)
  const [add, setAdd] = useState(0)
  const [update, setUpdate] = useState(0)
  const [supprimer, setSupprimer] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [modalNotif, setModalNotif] = useState(false)
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    alwaysShowAllBtns: true,
    sizePerPage: 30,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  const addFile = e => {
    var file = e.target.files[0]
    setFile(file)
  }
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "enseignants",
      text: props.t("Enseignant"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "titre",
      text: props.t("Titre"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "contenu",
      text: props.t("Description"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      formatter: cell => {
        if (!cell) return ""
        const words = cell.split(" ")
        if (words.length > 7) {
          const firstLine = words.slice(0, 7).join(" ")
          const rest = words.slice(7).join(" ")
          return (
            <>
              {firstLine} <br /> {rest}
            </>
          )
        }
        return cell
      },
    },
    {
      dataField: "notifier",
      text: props.t("Notifier"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture != 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#5ad66e", cursor: "pointer" }}
              onClick={() => toggleNotifier(row.id)}
              className="fas fa-bell "
            ></i>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-bell "
              title="L'année est clôturer"
            ></i>
          </div>
        ),
    },
    {
      dataField: "Modifier",
      isDummyField: true,
      text: props.t("Modifier"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture != 1 ? (
          update == 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "cornflowerblue", cursor: "pointer" }}
                onClick={() => getById(row.id)}
                className="fas fa-edit"
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                className="fas fa-edit"
                title="Vous n'avez pas le droit de modifier l'avis enseignant"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-edit"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
    {
      dataField: "id",
      isDummyField: true,
      text: "Téléchargement",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <a
          onClick={() => download2(row.id, row.titre)}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <i
            style={{ color: "#955cd5", cursor: "pointer" }}
            className="fas fa-file-download"
          ></i>
        </a>
      ),
    },
    {
      dataField: "active",
      isDummyField: true,
      text: "Etat",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (colIndex, row) =>
        cloture != 1 ? (
          update == 1 ? (
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              className="me-1 mb-sm-8 mb-2"
              onColor="#34c38f"
              onChange={() => activeAvis(row)}
              checked={row.active}
            />
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Switch
                title="Vous n'avez pas le droit de modifier l'avis enseignant"
                uncheckedIcon={<Offsymbol />}
                checkedIcon={<OnSymbol />}
                className="me-1 mb-sm-8 mb-2"
                onColor="#34c38f"
                onChange={() => activeAvis(row)}
                checked={row.active}
                disabled={true}
              />
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Switch
              title="Année clôturée"
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              className="me-1 mb-sm-8 mb-2"
              onColor="#34c38f"
              onChange={() => activeAvis(row)}
              checked={row.active}
              disabled={true}
            />
          </div>
        ),
    },
    {
      dataField: "Suppression",
      isDummyField: true,
      text: props.t("Suppression"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture != 1 ? (
          supprimer == 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#ED6464", cursor: "pointer" }}
                onClick={() => toggle(row.id)}
                className="fas fa-trash-alt"
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                className="fas fa-trash-alt"
                title="Vous n'avez pas le droit de supprimer l'avis enseignant"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-trash-alt"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
  ]
  const toggleNotifier = avisId => {
    if (avisId && typeof avisId !== "object") setDeleteId(avisId)
    setModalNotif(current => !current)
  }
  const download2 = async (id, titre) => {
    try {
      // On attend la réponse avec await
      const res = await API.post(
        "avis/download",
        {
          id: id,
        },
        { responseType: "blob" } // Important pour les fichiers binaires
      )
      // On télécharge le fichier avec le nom souhaité
      FileDownload(res.data, `${titre}.pdf`)
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error)
      toast.error("❌ Échec du téléchargement", { containerId: "A" })
    }
  }
  const { SearchBar } = Search
  useEffect(() => {
    const initialize = async () => {
    const loadData = async () => {
      try {
        const cloture_annee = JSON.parse(localStorage.getItem("cloture"))
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem("UserMenu")) || []
        const typeArticleSubMenu = userAuth.find(
          user =>
            Array.isArray(user.sous_menu) &&
            user.sous_menu.some(
              subMenu => subMenu.sous_menu === "Avis pour les enseignants"
            )
        )
        if (typeArticleSubMenu) {
          const menu = typeArticleSubMenu.sous_menu.find(
            subMenu => subMenu.sous_menu === "Avis pour les enseignants"
          )
          if (menu) {
            setAdd(menu.add)
            setUpdate(menu.edit)
            setSupprimer(menu.delete)
          }
        } else {
          console.warn(
            "Le sous-menu 'Avis pour les enseignants' est introuvable."
          )
        }
      } catch (error) {
        console.error(error)
      }
    }

    loadData()
    const resE = await API.post("enseignant/select", { annee_id }).then(
      resE => {
        setEnseignant(resE.data.select_enseignant)
      }
    )
    const res = await API.post("avis/liste_avis", { annee_id }).then(res => {
      setOrders(res.data.Avis)
    })
    setLoading(true)
    }
    initialize().catch(error => {
      console.error(error)
      toast.error("Erreur lors du chargement", { containerId: "A" })
      setLoading(true)
    })
  }, [])
  const refreshAvis = async () => {
    const res = await API.post("avis/liste_avis", { annee_id })
    setOrders(res.data?.Avis || [])
  }

  const resetForm = () => {
    setId("")
    setSelectOption(null)
    setSelectEnseignant([])
    setTitle("")
    setDescription("")
    setStatus(0)
    setFile(null)
    if (fileInputRef.current) fileInputRef.current.value = ""
  }

  const validateAvis = editing => {
    if (![1, 2].includes(selectOption?.value)) {
      toast.error("Veuillez choisir une option", { containerId: "A" })
      return false
    }
    if (selectOption.value === 2 && !selectEnseignant.length) {
      toast.error("Veuillez sélectionner au moins un enseignant", { containerId: "A" })
      return false
    }
    if (!title.trim()) {
      toast.error("Veuillez saisir un titre", { containerId: "A" })
      return false
    }
    if (!description.trim()) {
      toast.error("Veuillez saisir une description", { containerId: "A" })
      return false
    }
    if (!editing && !file) {
      toast.error("Veuillez sélectionner un fichier PDF", { containerId: "A" })
      return false
    }
    if (file && !file.name.toLowerCase().endsWith(".pdf")) {
      toast.error("Veuillez choisir un fichier PDF", { containerId: "A" })
      return false
    }
    return true
  }

  const buildFormData = () => {
    const formData = new FormData()
    formData.append("titre", title.trim())
    formData.append("contenu", description)
    formData.append("annee_id", annee_id)
    formData.append("active", status)
    formData.append("target_type", selectOption.value)
    formData.append(
      "enseignant_ids",
      JSON.stringify(
        selectOption.value === 2
          ? selectEnseignant.map(item => item.value)
          : []
      )
    )
    if (file) formData.append("fichier", file)
    return formData
  }

  const submit = async editing => {
    if (saving || !validateAvis(editing)) return
    setSaving(true)
    try {
      const formData = buildFormData()
      if (editing) formData.append("id", id)
      const res = await API.post(
        editing ? "avis/edit_avis" : "avis/add_avis",
        formData
      )
      if (Number(res.data?.errNum) === 200) {
        toast.success(
          editing
            ? "Avis Enseignant modifié avec succès"
            : "Avis Enseignant ajouté avec succès",
          { containerId: "A" }
        )
        resetForm()
        await refreshAvis()
      } else {
        toast.error(res.data?.message || "Enregistrement non confirmé", {
          containerId: "A",
        })
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement :", error)
      toast.error("Une erreur est survenue", { containerId: "A" })
    } finally {
      setSaving(false)
    }
  }

  const save = () => submit(false)
  const edit = () => submit(true)
  const annuler = () => resetForm()

  const toggle = avisId => {
    if (avisId && typeof avisId !== "object") setDeleteId(avisId)
    setModal(current => !current)
  }

  const getById = async avisId => {
    try {
      const res = await API.post("avis/get_by_id", { id: avisId })
      const avis = res.data?.Avis
      if (!avis) throw new Error("Avis introuvable")
      const destinataires = Array.isArray(avis.destinataires)
        ? avis.destinataires
        : []
      const targetType = Number(
        avis.target_type ?? avis.option ?? (destinataires.length ? 2 : 1)
      )
      setId(avis.id)
      setSelectOption(
        OPTIONS_ENSEIGNANTS.find(item => item.value === targetType) || null
      )
      setSelectEnseignant(targetType === 2 ? destinataires : [])
      setTitle(avis.titre || "")
      setDescription(avis.contenu || "")
      setStatus(Number(avis.active) === 1 ? 1 : 0)
      setFile(null)
      if (fileInputRef.current) fileInputRef.current.value = ""
    } catch (error) {
      console.error(error)
      toast.error("Impossible de charger l'avis", { containerId: "A" })
    }
  }

  const toggleDelete = async () => {
    if (!deleteId) return
    try {
      await API.post("avis/delete_avis", { id: deleteId, annee_id, user_id })
      setModal(false)
      setDeleteId(null)
      await refreshAvis()
    } catch (error) {
      console.error(error)
      toast.error("Échec de la suppression", { containerId: "A" })
    }
  }

  const Offsymbol = () => {
    return (
      <div
        title="Activé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        A
      </div>
    )
  }

  const OnSymbol = props => {
    return (
      <div
        title="Désactivé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        D
      </div>
    )
  }
  const notifyError = message => toast.error(message, { containerId: "A" })
  const notifySuccess = message => toast.success(message, { containerId: "A" })
  const activeAvis = async row => {
    var active = row.active
    var avis_id = row.id
    if (active == 0) {
      var active = 1
      const res = await API.post("avis/update_etat", {
        id: avis_id,
        active: active,
      }).then(res => {
        toast.success(" 🔓✔️ Avis enseignant Activé Avec succès", {
          containerId: "A",
        })
        API.post("avis/liste_avis", { annee_id }).then(resE => {
          setOrders(resE.data.Avis)
          setLoading(true)
        })
      })
    } else if (active == 1) {
      var active = 0
      const res = await API.post("avis/update_etat", {
        id: avis_id,
        active: active,
      }).then(res => {
        toast.success(" 🔒❌ Avis enseignant Désactivé Avec succès ", {
          containerId: "A",
        })
        API.post("avis/liste_avis", { annee_id }).then(resE => {
          setOrders(resE.data.Avis)
          setLoading(true)
        })
      })
    }
  }
  const toggleNotifierEtd = async () => {
    if (!deleteId) return
    try {
      await API.post("avis/send_email", {
        avis_id: deleteId,
        annee_id,
        user_id,
      })
      setModal(false)
      setDeleteId(null)
      await refreshAvis()
      notifySuccess("Avis Notifié")
    } catch (error) {
      console.error(error)
      notifyError("Échec de la notification")
    }
  }
  const toggleNotifierRe = async () => {
    if (!deleteId) return
    try {
      await API.post("avis/send_email", {
        avis_id: deleteId,
        annee_id,
        user_id,
        force: 1,
      })
      setModal(false)
      setDeleteId(null)
      await refreshAvis()
      notifySuccess("Avis Notifié")
    } catch (error) {
      console.error(error)
      notifyError("Échec de la notification")
    }
  }
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Fragment>
            <AvForm>
              <Row>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Option :</Label>
                    <Select
                      options={OPTIONS_ENSEIGNANTS}
                      value={selectOption}
                      isSearchable={true}
                      isClearable={false}
                      onChange={e => {
                        setSelectOption(e)
                        setSelectEnseignant([])
                      }}
                      placeholder={props.t("Select")}
                    />
                  </div>
                </Col>
                {selectOption?.value === 2 && (
                  <Col lg="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Enseignant :
                      </Label>
                      <Select
                        options={enseignant}
                        value={selectEnseignant}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        onChange={e => setSelectEnseignant(e || [])}
                        placeholder={props.t("Select")}
                      />
                    </div>
                  </Col>
                )}
                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Fichier :</Label>
                    <Input
                      onChange={e => addFile(e)}
                      className="form-control"
                      type="file"
                      id="formFile"
                      innerRef={fileInputRef}
                      accept=".pdf"
                    />
                  </div>
                </Col>
                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Titre :</Label>
                    <Input
                      lg="3"
                      className="form-control"
                      placeholder="Titre"
                      type="text"
                      value={title}
                      onChange={e => setTitle(e.target.value)}
                    />
                  </div>
                </Col>
                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Description :
                    </Label>
                    <Input
                      value={description}
                      lg="3"
                      className="form-control"
                      placeholder="Description ..."
                      type="textarea"
                      onChange={e => setDescription(e.target.value)}
                    />
                  </div>
                </Col>
                <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Etat :</Label>
                    <Switch
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      checked={status === 1}
                      className="me-1 mb-sm-8 mb-2"
                      onColor="#34c38f"
                      onChange={checked => setStatus(checked ? 1 : 0)}
                    />
                  </div>
                </Col>
              </Row>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {add === 1 && id === "" && (
                  <Col lg="6">
                    <div className="text-center mt-4">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={save}
                        disabled={saving}
                      >
                        {props.t("Confirmer")}
                      </button>
                    </div>
                  </Col>
                )}
                {update === 1 && id !== "" && (
                  <Col lg="6">
                    <div className="text-center mt-4">
                      <button
                        type="button"
                        className="btn btn-warning"
                        onClick={edit}
                        disabled={saving}
                      >
                        {props.t("Modifier")}
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={annuler}
                        disabled={saving}
                      >
                        {props.t("Annuler")}
                      </button>
                    </div>
                  </Col>
                )}
              </div>
            </AvForm>
            <Row className="mt-4">
              <Col xs="12">
                <ToolkitProvider
                  keyField="id"
                  data={orders}
                  columns={Columns()}
                  search
                  bootstrap4
                >
                  {toolkitProps => (
                    <div>
                      <div>
                        <div className="mb-3 row" style={{ display: "flex" }}>
                          <div className="col-md-6 mb-3 row">
                            <div className="col-md-8 search-box-etd">
                              <div
                                className="search-box me-2 mb-2 d-inline-block"
                                style={{ width: "100%" }}
                              >
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <BootstrapTable
                        wrapperClasses="table-responsive"
                        noDataIndication={() => <NoDataIndication />}
                        striped={false}
                        bordered={false}
                        classes={"table align-middle table-nowrap"}
                        headerWrapperClasses={"table-light"}
                        hover
                        pagination={paginationFactory(pageOptions)}
                        {...toolkitProps.baseProps}
                      />
                    </div>
                  )}
                </ToolkitProvider>
              </Col>
            </Row>
          </Fragment>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement")} ...{" "}
            </h4>
          </div>
        )}
      </div>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {props.t("Suppression")} {props.t("d'avis enseignant")}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>{props.t("Voulez-vous supprimer cette avis ?")}</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDelete}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {props.t("Oui")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Non")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalNotif} toggle={() => toggleNotifier()} centered>
        <ModalHeader toggle={() => toggleNotifier()}>
          {props.t("Notifier ")} {props.t("d'avis étudiant")}
        </ModalHeader>
        <ModalBody>
          <p className="text-center">Voulez-vous notifier cet avis ?</p>
          <div className="d-flex justify-content-around">
            <Button color="info" onClick={toggleNotifierEtd}>
              Oui
            </Button>
            <Button color="success" onClick={() => toggleNotifierRe()}>
              Réenvoyer
            </Button>
            <Button color="danger" onClick={() => toggleNotifier()}>
              Non
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableAvisEnseignant))
DataTableAvisEnseignant.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}

